import { clsx } from 'clsx';
import { PropsWithChildren } from 'react';

const style = clsx('flex', 'items-center', 'flex-wrap', 'gap-xxs');

type Props = PropsWithChildren;

/**
 * @package
 */
export const ButtonGroupWrap = ({ children }: Props) => {
  return <div className={clsx(style)}>{children}</div>;
};
